<template>
  <div class="relative" :class="[open ? 'z-20' : 'z-10', colSpan]">
    <!-- LABEL -->
    <label
      :for="handle || formField.handle"
      class="mb-2 block text-grey-300 typo-subtitle"
    >
      {{ shouldTranslate ? $t(`forms.${formField.handle}`) : (label || formField.label || formField.display) }}{{ isRequired ? '*' : '' }}
    </label>

    <!-- SELECT -->
    <Field
      :id="handle || formField.handle"
      v-slot="{ field, setValue }"
      :name="handle || formField.handle"
      :label="label || formField.label || formField.display"
      :disabled="disabled"
      :rules="rulesAsString"
    >
      <InputFormSelect
        v-model="selectedValue"
        :handle="formField.handle"
        :options="computedOptions"
        v-bind="field"
        :placeholder="placeholder || formField?.config?.placeholder"
        :error="error"
        @update:model-value="(option) => setValue(option?.key || '')"
        @update:open="open = $event"
      />
    </Field>

    <!-- ERROR -->
    <FieldError :error="error" />
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import { Field } from 'vee-validate'

const props = defineProps({
  handle: {
    type: String,
    default: null,
  },
  formField: {
    type: Object,
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
  rules: {
    type: [Array, String],
    default: '',
  },
  error: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  width: {
    type: [Number, String],
    default: null,
  },
  options: {
    type: [Array, Object],
    default: () => [],
  },
})

const shouldTranslate = inject('shouldTranslate', false)

const selectedValue = ref({})

const rulesAsString = useFilterVeeValidateRules(props.rules)

const colSpan = computed(() => {
  const width = parseInt(props.width) || props.formField?.width || 100

  switch (width) {
    case 25:
      return 'lg:col-span-3 col-span-12'
    case 33:
      return 'lg:col-span-4 col-span-12'
    case 50:
      return 'lg:col-span-6 col-span-12'
    case 66:
      return 'lg:col-span-8 col-span-12'
    default:
      return 'lg:col-span-12 col-span-12'
  }
})

const isRequired = computed(() => {
  return props.rules.includes('required')
})

const computedOptions = computed(() => {
  if (props.formField?.config?.options) {
    return Object.values(props.formField.config.options)
  }

  if (props.options?.length > 0) return props.options

  return []
})

const open = ref(false)
</script>
